import { useNavigate } from 'react-router-dom';

interface BackWithCustomTextProps {
  statement?: string;
  clickLabel?: string;
  onClick?: () => void;
}

const BackWithCustomText = (props: BackWithCustomTextProps) => {
  const { statement = '', clickLabel = '< Back', onClick } = props;

  const navigate = useNavigate();

  const navigateBack = () => {
    if (onClick) {
      onClick();
      return;
    }
    navigate(-1);
  };

  return (
    <div
      className="mt-2 cursor-pointer text-sm text-grey "
      role="presentation"
      onClick={navigateBack}
    >
      <span className="text-primary">{clickLabel} </span>
      {!!statement && <span>{statement}</span>}
    </div>
  );
};

export default BackWithCustomText;
